import styled from 'styled-components'
import {
  txt12OpenSansBold,
  txt14OpenSans,
  txt14OpenSansBold
} from '../../../../../styles/settings/types'
import {
  linkNavyBlue,
  white,
  ghostWhite,
  paleGrayTwo,
  graySuit
} from '../../../../../styles/settings/colors'
import rem from '../../../../../styles/tools/rem'
import media from '../../../../../styles/tools/media'

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 960px;
  ${media.small`
        padding: ${rem('16px')};
    `};
  ${media.large`
        margin: 40px 0px;
    `};
`

export const TableCell = styled.p`
  display: inline-block;
  overflow: hidden;

  ${media.small`
        ${({ mobileWidth, width }) => `width: ${mobileWidth || width};`};
        ${({ showInMobile }) => `display: ${showInMobile ? 'inline-block' : 'none'};`};
    `};
  ${media.large`
        ${({ width }) => `width: ${width};`};
    `};
`

export const TableHeader = styled.div`
  border-top: 1px solid ${paleGrayTwo};
  border-bottom: 1px solid ${paleGrayTwo};
  display: flex;
  flex-direction: row;
  height: 40px;
  width: 100%;
`

export const TableHeaderCell = styled(TableCell)`
  ${txt12OpenSansBold} margin: 10px;
  color: ${graySuit};
`

export const TableRow = styled.div`
  display: flex;
  flex-direction: row;
  height: 40px;
  width: 100%;
  ${({ index }) => `background-color: ${index % 2 === 0 ? white : ghostWhite};`};
`

export const TableRowCell = styled(TableCell)`
  ${txt14OpenSans} margin: 10px;
  color: ${linkNavyBlue};
  white-space: nowrap;
`

export const TableRowCellBold = styled(TableRowCell)`
  ${txt14OpenSansBold};
`



// WEBPACK FOOTER //
// ./src/app/pages/ec/RequestFile/table/styles.js